import {createSelector, moment} from 'helpers';
import {RootState} from 'store/root-state.type';

export const session = (state: RootState) => state.session;

export const online = (state: RootState) => !state.session.offline;

export const offline = (state: RootState) => state.session.offline;

export const subscription = createSelector(
  (state: RootState) => JSON.stringify(state.session.subscription),
  (string => JSON.parse(string) as RootState['session']['subscription'])
);

export const user = createSelector(
  (state: RootState) => JSON.stringify(state.session.user || null),
  (string => JSON.parse(string) as RootState['session']['user'])
);

export const userIsOnline = createSelector(
  [user, online],
  (user, online) => Boolean(user && online),
);

export const time = createSelector(
  (state: RootState) => state.session.minute,
  (moment.unix)
);

export const today = createSelector(
  [(state: RootState) => state.session.today, (state: RootState) => state.session.locale],
  (moment.unix)
);

export const isNight = createSelector(
  (state: RootState) => state.session.hour,
  (ts => moment.unix(ts).hour() < 4)
);
